/// Quem depende de saldo não tem o que escolher enquanto a unidade não recebeu mercadoria. O aviso
/// diz o caminho, porque um campo de local vazio não explica nada.
export function NoStockLocationNotice() {
  return (
    <p role="status" className="text-sm text-warning">
      Esta unidade ainda não tem local de estoque. Ele é criado na primeira Entrada de mercadoria,
      com o nome Depósito.
    </p>
  );
}

/// Na própria entrada o local nasce junto, e a pessoa só precisa saber que isso vai acontecer.
export function FirstStockLocationNotice() {
  return (
    <p role="status" className="text-sm text-content-muted">
      O local Depósito será criado junto com esta entrada. Você pode renomeá-lo depois em Estoque ›
      Locais.
    </p>
  );
}
